import { Component } from '@angular/core';
import { ConfigStore } from '@app/app-configs/config-store';

@Component({
    selector: 'report-page-footer',
    templateUrl: './report-page-footer.component.html',
    styleUrls: ['./report-page-footer.component.scss'],
    standalone: false
})
export class ReportPageFooterComponent {
	public readonly date = new Date();
	public readonly vendor:string=ConfigStore.get('branding.vendor');
}
